import React from "react"
import PropTypes from "prop-types"
import { StyledField, Hint } from "./styles"
import Markdown from "../../markdown"

const TextField = ({ handleInputChange, hint, ...rest }) => {
  const onChange = (event) => {
    const { name, value } = event.target
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  return (
    <>
      <StyledField type="text" onChange={onChange} {...rest} />
      {hint && (
        <Hint>
          <Markdown
            componentStyles={{
              p: { variant: rest.hintVariant || "default" },
              li: { variant: rest.hintVariant || "default" },
              a: { variant: rest.hintVariant || "default" }
            }}
          >
            {hint}
          </Markdown>
        </Hint>
      )}
    </>
  )
}

TextField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
}

TextField.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  invalid: false
}

export default TextField
